import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { PaymentTransactionExtension } from 'app/models/extensions/payment-transaction-extension.model';
import { LOVPaymentMethod } from 'app/models/lov-payment-method.model';
import { OtherPayment } from 'app/models/other-payment.model';
import { ProcessedEntityPayment } from 'app/models/processed-entity-payment.model';

export class PaymentTransaction extends PaymentTransactionExtension {
  paymentTransactionDBID: number = 0;
  paymentMethodDBID?: number = null;
  chequeNumber: string = null;
  amount?: number = null;
  receivedDT?: Date = null;
  postedDT?: Date = null;
  exported?: boolean = null;
  createdDT: Date = new Date();
  createdBy: string = null;
  modifiedDT: Date = new Date();
  modifiedBy: string = null;
  rowVersion: number = 0;
  paymentMethod: LOVPaymentMethod = null;
  otherPayments: OtherPayment[] = [];
  processedEntityPayments: ProcessedEntityPayment[] = [];

  static getForm(disableAll: boolean = false, includeNav: string[] = []): FormGroup {
    const form = new FormGroup({
      paymentTransactionDBID: new FormControl({ value: 0, disabled: disableAll }),
      paymentMethodDBID: new FormControl({ value: null, disabled: disableAll }),
      chequeNumber: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(15)]),
      amount: new FormControl({ value: null, disabled: disableAll }),
      receivedDT: new FormControl({ value: null, disabled: disableAll }),
      postedDT: new FormControl({ value: null, disabled: disableAll }),
      exported: new FormControl({ value: null, disabled: disableAll }),
      createdDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      createdBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      modifiedDT: new FormControl({ value: new Date(), disabled: disableAll }, [Validators.required]),
      modifiedBy: new FormControl({ value: null, disabled: disableAll }, [Validators.maxLength(50)]),
      rowVersion: new FormControl({ value: 0, disabled: disableAll }),
      otherPayments: new FormArray([]),
      processedEntityPayments: new FormArray([])
    });

    // Only add navigational properties to the form when needed.
    // If navigational properties are included they MUST NOT be null when patching the form.
    if (includeNav.length > 0) {
      for (const key of includeNav) {
        switch (key.toLowerCase()) {
          case 'paymentmethod':
            form.addControl('paymentMethod', LOVPaymentMethod.getForm(disableAll)); break;
          default:
            // tslint:disable-next-line:max-line-length
            throw new Error(`'${key}' is not a property of PaymentTransaction. Please use one of the following navigational property: 'paymentMethod'`);
        }
      }
    }

    return form;
  }
}